import React, { useState, useEffect } from "react";
import ToggleWithText from "./ToggleWithText";

const DaysToggles = ({
  dailyAvailability,
  setDailyAvailability,
  updateValidationState,
  onAvailabilityUpdate,
}) => {
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const [validationStates, setValidationStates] = useState({});

  useEffect(() => {
    const allValid = Object.values(validationStates).every(
      (isValid) => isValid
    );
    updateValidationState(allValid);
  }, [validationStates, updateValidationState]);

  const updateDailyAvailability = (day, slots) => {
    console.log(`Updated availability from DaysToggle for ${day}:`, slots);
    const updatedAvailability = {
      ...dailyAvailability,
      [day]: slots,
    };

    setDailyAvailability(updatedAvailability);
    onAvailabilityUpdate(updatedAvailability);
  };
  const reportValidation = (day, isValid) => {
    setValidationStates((prev) => ({ ...prev, [day]: isValid }));
  };

  return (
    <>
      {days.map((day) => (
        <ToggleWithText
          key={day}
          text={day}
          initialAvailability={dailyAvailability[day] || []}
          onUpdate={updateDailyAvailability}
          reportValidation={reportValidation}
        />
      ))}
    </>
  );
};

export default DaysToggles;
